import React, { FC } from 'react'
import styled from 'styled-components'

import conditional, { whenProps } from 'tools/conditional'

import type { IllustrationProps } from './EmptyState.types'

const Wrapper = styled.div<Pick<IllustrationProps, 'scale'>>`
  & > img:first-of-type,
  SVG:first-of-type {
    height: ${conditional({
      '240px': whenProps({ scale: 'large' }),
      '120px': whenProps({ scale: 'default' }),
    })};
    object-fit: cover;
  }
`

export const Illustration: FC<IllustrationProps> = ({
  illustration,
  scale,
  ...props
}: IllustrationProps) => (
  <Wrapper scale={scale} {...props}>
    {typeof illustration === 'string' ? <img src={illustration} alt="" /> : illustration}
  </Wrapper>
)

export default Illustration
